



































































































































import Vue from 'vue'
import QUERY from '@/graphql/affiliate/totalAffiliate.gql'
import XCard from '@/components/atoms/Card/XCard.vue'
import XPrice from '@/components/atoms/Price/XPrice.vue'
import XMonthPicker from '@/components/atoms/MonthPicker/XMonthPicker.vue'
import FfhProductTypeTable from '../FfhProductTypeTable.vue'
import CumulativeCard from '../_Partial/CumulativeCard.vue'
import LimitedCard from '../_Partial/LimitedCard.vue'
import { TotalAffiliateInput } from '@/types/generated/graphql'

type Data = {
  input: TotalAffiliateInput
}

export default Vue.extend<Data, {}, {}, {}>({
  name: 'TotalSetAffiliate',
  components: {
    XCard,
    XPrice,
    XMonthPicker,
    CumulativeCard,
    LimitedCard,
    FfhProductTypeTable,
  },
  data() {
    return {
      input: {
        partnerId: this.$route.params.partnerId,
        range: {
          from: undefined,
          to: undefined,
        },
      },
    }
  },
  apollo: {
    totalAffiliate: {
      query: QUERY,
      deep: true,
      variables() {
        return {
          input: this.input,
        }
      },
      fetchPolicy: 'network-only',
    },
  },
})
